/* Fix to be done: we should use svgs instead of emojis */
export const languageOptions = [
  {
    label: 'english',
    key: 'en_US',
    imgPath: '/assets/images/flags/US.png',
  },
  {
    label: 'spanish',
    key: 'es_MX',
    imgPath: '/assets/images/flags/MX.png',
  },
  {
    label: 'french',
    key: 'fr_CA',
    imgPath: '/assets/images/flags/CA.png',
  },
]
